import { BaseModel } from '@Core';

export enum TvStandards {
    Off = -1,
    NTSC = 0,
    PAL = 1,
}

export enum RateMode {
    CBR,
    VBR,
}

export enum VideoCodec {
    H264 = 0,
    MJPEG = 1,
    H265 = 3,
}

export enum H264Profile {
    BaseProfile,
    MainProfile,
    HighProfile,
}

export enum RateQuality {
    Low = 25,
    Medium = 50,
    High = 60,
    Higher = 75,
}

export enum VbrQuality {
    Low,
    Medium,
    High,
}

export enum StreamEnable {
    Disable,
    Enable,
}

export enum FishDisplayModel {
    Model10,
    Model1P,
    Model2P,
    Model2R,
    Model4R,
    Model1O3R,
    Model1P3R,
    Model1O1P3R,
}

export enum FishInstallModel {
    Ceiling,
    Wall,
    Flat,
}

export enum FishCorrectModel {
    MultiChannelMode,
    BundleStreamMode,
}

export interface StreamSetting {
    Width: number;
    Height: number;
    Url: string;
    ProfileGop: number;
    RateMode: RateMode;
    Framerate: number;
    Bitrate: number;
    SmartStreamEnable: number;
    SmartStreamLevel: number;
    Profile: H264Profile;
    ProfileCodec: VideoCodec;
    RateQuality: RateQuality;
    VbrQuality: VbrQuality;
    Enable: StreamEnable;
}

export interface SP111VideoGeneral extends BaseModel {
    DevMac: string;
    DeviceModel: string;
    DeviceSensor: string;
    DeviceTvStandards: TvStandards;
    StreamList: {
        MainStream: StreamSetting;
        SubStream: StreamSetting;
        ThirdStream: StreamSetting;
    };
    CTvStandards: TvStandards;
    RtspPort: number;
    EventStreamEnable: number;
    EventStreamFramerate: number;
    EventStreamBitrate: number;
    EventStreamIframe: number;
    FishDisplayModel: FishDisplayModel;
    FishInstallModel: FishInstallModel;
    FishCorrectModel: FishCorrectModel;
    MainCodecres: VideoCodec;
    ImageScheMode: number;
    HlcMode: number;
    Exposurectrl: number;
    WdrEnable: number;
}
